module.exports = __webpack_public_path__ + "img/crm-solution-listing.ebd897ab.jpg";